<div
  class="date-range-row"
  *ngFor="let dateRange of dateRanges$ | async; let i = index"
  [attr.data-cy]="'date-range-row-' + i">
  <div
    class="date-range-remove-icon"
    *ngIf="(dateRanges$ | async)?.length && (dateRanges$ | async)!.length > 1">
    <button
      class="outline-pill-button icon-only"
      type="button"
      (click)="removeDateRangeAt(i)"
      data-cy="remove-date-range-button">
      <mat-icon svgIcon="minus"></mat-icon>
    </button>
  </div>
  <div class="date-range-dates">
    <div class="row">
      <div
        data-cy="datepicker"
        [class.col]="isDisabled$ | async"
        [class.col-sm-6]="!(isDisabled$ | async)">
        <mat-form-field class="light-form-field">
          <mat-label
            *ngIf="!dateRange.to"
            [class.warning]="(showValidation$ | async) && !dateRange.from"
            >{{ ("date" | i18n) || "Datum" | titlecase }}</mat-label
          >
          <mat-label
            *ngIf="dateRange.to"
            [class.warning]="(showValidation$ | async) && !dateRange.to"
            >{{ ("dateFrom" | i18n) || "Datum von" | titlecase }}</mat-label
          >
          <input
            matInput
            [value]="dateRange.from | date"
            readonly
            (click)="datePickerFrom.open()"
            required
            [disabled]="!!(isDisabled$ | async)"
            data-cy="datepicker-from" />
          <input
            matInput
            required
            [name]="'datepickerFrom' + i"
            (dateChange)="resolveDateRangesChange()"
            (click)="datePickerFrom.open()"
            [matDatepicker]="datePickerFrom"
            [(ngModel)]="dateRange.from"
            [disabled]="!!(isDisabled$ | async)"
            [class.warning]="(showValidation$ | async) && !dateRange.from"
            hidden />
          <mat-datepicker-toggle
            matSuffix
            [for]="datePickerFrom"></mat-datepicker-toggle>
          <mat-datepicker
            #datePickerFrom
            [startAt]="dateRange.from || null"></mat-datepicker>
        </mat-form-field>
      </div>
      <div
        class="col-sm-6 flex-center"
        *ngIf="!(isDisabled$ | async)">
        <mat-form-field
          [class.hidden]="!dateRange.to"
          class="light-form-field">
          <mat-label
            [class.warning]="(showValidation$ | async) && !dateRange.to"
            >{{ ("dateTo" | i18n) || "Datum bis" | titlecase }}</mat-label
          >
          <input
            matInput
            [value]="dateRange.to ? (dateRange.to | date) : ''"
            readonly
            (click)="datePickerTo.open()"
            required
            data-cy="datepicker-to" />
          <input
            matInput
            [name]="'datepickerTo' + i"
            (dateChange)="resolveDateRangesChange()"
            (click)="datePickerTo.open()"
            [matDatepicker]="datePickerTo"
            [(ngModel)]="dateRange.to"
            [value]="dateRange.to"
            [disabled]="!!(isDisabled$ | async)"
            [min]="dateRange.from"
            [class.warning]="(showValidation$ | async) && !dateRange.to"
            hidden />
          <mat-datepicker-toggle
            matSuffix
            [for]="datePickerTo"></mat-datepicker-toggle>
          <mat-datepicker
            #datePickerTo
            [startAt]="dateRange.to || null"></mat-datepicker>
        </mat-form-field>
        <button
          [class.hidden]="dateRange.to"
          class="add-to-date-button text-icon-button"
          mat-button
          type="button"
          (click)="addDateRangeFieldTo(dateRange, datePickerTo)"
          data-cy="add-to-date-button">
          <mat-icon
            class="text-icon-button-icon"
            svgIcon="plus"></mat-icon>
          <span>{{ ("addToField" | i18n) || "Bis hinzufügen" }}</span>
        </button>
      </div>
    </div>
  </div>
  <div
    class="date-range-remove-to"
    *ngIf="!(isDisabled$ | async)">
    <button
      *ngIf="dateRange.to"
      class="remove-to-date-button text-icon-button"
      mat-button
      type="button"
      (click)="removeDateRangeFieldTo(dateRange)"
      data-cy="remove-to-date-button">
      <mat-icon
        class="text-icon-button-icon"
        svgIcon="close"></mat-icon>
      <span>{{ ("removeToField" | i18n) || "Bis entfernen" }}</span>
    </button>
  </div>
</div>
<button
  *ngIf="!(isDisabled$ | async)"
  class="add-date-range-button text-icon-button"
  mat-button
  type="button"
  (click)="createDateRange()"
  data-cy="add-date-range-button">
  <mat-icon
    class="text-icon-button-icon"
    svgIcon="plus"></mat-icon>
  <span>{{ ("addAnotherDate" | i18n) || "Weiteres Datum hinzufügen" }}</span>
</button>
